import * as React from 'react';
import { useParams } from 'react-router-dom';

import { Program } from 'base/api/types';
import { STATUSES_OPTIONS } from 'common/consts';
import { PK, SelectOption } from 'common/types';
import { DetailsCard, DetailsSuspense } from 'templates/details';

import ProgramCore from '../components/ProgramCore';
import { fields, ProgramCategoryMap, ProgramFields } from '../consts';
import { useProgramCategoryList, useProgramDetails } from '../queries';

export const categoryValueToOption = (
  value: string,
  categories: ProgramCategoryMap,
): SelectOption<string>[] => {
  const label = categories[value];

  return [{ value, label }];
};

const transformProgram = (
  raw: Program,
  categories: ProgramCategoryMap,
): ProgramFields => ({
  [fields.title.name]: raw.title,
  [fields.short_description.name]: raw.short_description,
  [fields.description.name]: raw.description,
  [fields.status.name]: STATUSES_OPTIONS.filter(({ value }) => value === raw.status),
  [fields.category.name]: categoryValueToOption(raw.category, categories),
});

const ProgramDetails = () => {
  const { pk } = useParams<{ pk?: PK }>();
  const { data, ...query } = useProgramDetails(pk);
  const { data: categoriesData } = useProgramCategoryList();
  const defaultValues = data && categoriesData && transformProgram(data, categoriesData);

  return (
    <DetailsCard created={data?.created_at} lastUpdate={data?.modified_at}>
      <DetailsSuspense isLoading={query.isLoading} error={query.error}>
        <ProgramCore pk={pk} blog_pk={data?.blog_pk} defaultValues={defaultValues} />
      </DetailsSuspense>
    </DetailsCard>
  );
};

export default ProgramDetails;
